* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;

  .incident-history-title {
    padding: calc(var(--spacer) * 7) calc(var(--spacer) * 2) var(--spacer) calc(var(--spacer) * 2);
    color: var(--main-titles-inputs-600);
  }

  .image-repo-title {
    margin-bottom: calc(var(--spacer) * 2 - 4px);
  }

  .image-repo-text {
    margin-bottom: calc(var(--spacer) * 3);
  }

  .empty-state,
  .error-state {
    height: calc(100% - 89px);
    display: none;
  }

  .side-menu-content {
    height: 100%;
    overflow: hidden;
  }

  .loading-state {
    display: none;
  }

  .loading-state-scroll {
    display: none;
  }

  &.is-loading {
    .loading-state {
      display: block;
      padding: calc(var(--spacer) * 2);
    }
    .empty-state {
      display: none;
    }
    .incident-history-list {
      display: none;
    }
  }

  &.is-loading-scroll {
    .loading-state-scroll {
      display: block;
      padding: calc(var(--spacer) * 2);
    }
  }

  &.is-empty {
    .empty-state {
      display: block;
    }
    .incident-history-list {
      display: none;
    }
  }

  &.is-error {
    .error-state {
      display: block;
    }
    .incident-history-list {
      display: none;
    }
  }

  .incident-history-list {
    max-height: calc(100% - 85px);
    height: auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding: var(--spacer) calc(var(--spacer) * 2) calc(var(--spacer) * 2) calc(var(--spacer) * 2);
    display: flex;
    flex-flow: column-reverse;
  }

  gz-card-history {
    height: auto;
  }

  gz-card-history {
    margin-bottom: calc(var(--spacer) * 2);
    padding-top: var(--spacer);
    border-top: 1px solid var(--chart-101-pressed-dividers);
  }

  gz-card-history:last-of-type {
    border: none;
    margin-bottom: calc(var(--spacer) * 2);
  }
}
